import styled from 'styled-components';
import { white } from 'constants/colors';
import MaterialAvatar from '@material-ui/core/Avatar';

export const BubblesWrapper = styled.div`
  display: inline-block;
  vertical-align: middle;
`;

export const BubbleElement = styled.div`
  display: inline-block;
  width: 95px;
  height: 110px;
  vertical-align: top;
  margin: 0 5px 5px 0;
`;

export const BubbleImage = styled(MaterialAvatar)`
  && {
    width: 60px;
    height: 60px;
    display: inline-block;
    border: 1px solid white;
    &.with-initial {
      font-size: 30px;
      padding-top: 13px;
    }
   }
`;

export const BubbleName = styled.div`
  color: ${white};
  font-size: 14px;
  line-height: 14px;
  margin-top: 5px;
`;



// WEBPACK FOOTER //
// ./src/components/Steps/Bubbles/components/styles.js